import * as Styles from '@screens/landing-page-team/styles';
import { TabContent } from '@screens/landing-page-team/types';
import PublisherCard from '@screens/lp-default/components/team/components/publisher-card';

type props = {
  screenData: TabContent;
};

export default function LandingPageTeam({ screenData }: props) {
  return (
    <>
      <Styles.Container data-testid="landing-page-team">
        <Styles.FadeOverlay />
        <Styles.TabDescription>{screenData.description}</Styles.TabDescription>
        <Styles.Content>
          <Styles.CardsWrapper>
            {screenData.publishers.map((publisher) => (
              <PublisherCard key={publisher.id} publisher={publisher} tab={screenData.tab} />
            ))}
          </Styles.CardsWrapper>
        </Styles.Content>
      </Styles.Container>
    </>
  );
}
